export * from '@primeuix/themes/nora/rating';
export { default } from '@primeuix/themes/nora/rating';
